import PortfolioClassic from "./PortfolioClassic";
import PortfolioExtreme from "./PortfolioExtreme";

const Portfolio = () => {
  const isExtreme =
    new URLSearchParams(window.location.search).get("version") === "extreme";
  return isExtreme ? <PortfolioExtreme /> : <PortfolioClassic />;
};

export default Portfolio;
